module.exports = __webpack_public_path__ + "img/bunny-ears-5.bcf5050b.svg";